import axios from 'axios';

const api = axios.create({
   baseURL: 'http://localhost:5003/api',
  //baseURL: 'https://node.metromenswear.com/api',
  withCredentials: true
});

// Add Authorization header interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('mmw_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('mmw_user');
      localStorage.removeItem('mmw_token');
    }
    return Promise.reject(error);
  }
);

export default api;
